export default __webpack_public_path__ + "static/media/blog-img183.0107c777.jpg";